import { useEffect } from "react";
import StepComplete from "../../../components/common/stepComplete/StepComplete";
import AppHeader from "../../../components/common/appHeader/AppHeader";
import { useDispatch } from "react-redux";
import { setIsComplete } from "@src/@slice/recommendHallSlice";

import { HOSTNAME, isExternalUrl, isWebview } from "@src/utils";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";
import { closeWebview } from "@src/utils/route";
import { sendRecommendHallChat } from "@src/api/recommend/recommend";
import HoneymoonSection from "@src/components/common/honeymoonSection/HoneymoonSection";
import { useRecommendHall } from "../../../utils/hooks/useRecommendHall";

const Complete = () => {
  const dispatch = useDispatch();
  const { hallData } = useRecommendHall();
  
  // 예식일에서 첫 번째 년월 추출 및 포맷팅 (예: "2026년 5월" -> "26년 5월")
  const formatWeddingMonth = (yearMonths: string[]): string => {
    if (!yearMonths || yearMonths.length === 0) return "26년 9월"; // 기본값
    const firstMonth = yearMonths[0]; // 첫 번째 선택된 예식일
    
    // "2026년 5월" 형식 파싱
    const yearMatch = firstMonth.match(/(\d{4})년/);
    const monthMatch = firstMonth.match(/(\d{1,2})월/);
    
    if (yearMatch && monthMatch) {
      const year = yearMatch[1];
      const month = monthMatch[1];
      const shortYear = year.slice(-2); // "2026" -> "26"
      const monthNum = parseInt(month, 10); // "5" -> 5
      return `${shortYear}년 ${monthNum}월`;
    }
    
    // 기존 형식 지원 (YYYY-MM)
    const [year, month] = firstMonth.split("-");
    if (year && month) {
      const shortYear = year.slice(-2);
      const monthNum = parseInt(month, 10);
      if (!isNaN(monthNum)) {
        return `${shortYear}년 ${monthNum}월`;
      }
    }
    
    return "26년 9월"; // 기본값
  };
  
  const honeymoonTitle = formatWeddingMonth(hallData.hopeWedding.yearMonths);

  useEffect(() => {
    const handleSendChat = async () => {
      try {
        const res = await sendRecommendHallChat();
        if (!res) {
          return;
        }
        if (res.status === 200) {
          dispatch(setIsComplete({ bool: true }));
        }
      } catch (error) {
        console.error("sendRecommendHallChat: 에러 발생", error);
      }
    };

    handleSendChat();
  }, [dispatch]);

  const handleButtonClick = () => {
    if (isWebview()) {
      // 앱 환경: 스킴으로 이동
      window.location.href = "h2mwbell://chat";
    } else {
      // 웹 환경: URL로 이동
      window.location.href = isExternalUrl(`${HOSTNAME}/mypage/chat`);
    }
  };

  return (
    <div className="recommend-hall-complete">
      {/* <AppHeader type="nonStack" actionItems={[{ name: "close" }]} /> */}
      <CustomHeader goBack={closeWebview} close={closeWebview} />
      {/* <AppHeader type="stack" actionItems={[{ name: "close" }]} headerPostion="fixed" /> */}
      <div className="complete-circle">
        <i className="icon icon-22 icon-check-white" />
      </div>
      <StepComplete
        title={`신청이 완료되었습니다.`}
        text={`희망 조건에 딱 맞는 웨딩홀 추천 리스트를
          알림톡과 웨딩북 채팅창으로 곧 보내드릴게요.`}
      />

      <p className="complete-sub-text">*더 정밀한 추천을 위해 담당자가 해피콜을 드릴 수 있어요.</p>

      {/* 신혼여행 섹션 */}
      <HoneymoonSection 
        title={`${honeymoonTitle} 허니문 추천`}
        description="웨딩홀 예약 커플의 75%가 벌써 신혼여행을 준비하고 있어요."
      />

      <div className="gradient-background"></div>
      <button className="btn btn-full btn-red500 btn-giant" onClick={handleButtonClick}>
        신청 내역 보기
      </button>
      {/* </div> */}
    </div>
  );
};

export default Complete;
